export const meta: BlockMeta = {
  title: "CTAs",
  tags: ["subpage"],
  flags: {
    fullWidth: true,
  },
}

import { defineBlock, EditableText, InnerBlocks } from "eddev/blocks"

export default defineBlock("content/expandable", (props) => {
  return (
    <div className="w-full my-7 px-4 flex flex-col md:flex-row justify-between items-center md:flex-nowrap gap-2 md:gap-4">
      <InnerBlocks
        allowedBlocks={["content/ctas-item"]}
        orientation="horizontal"
        adminClassName="w-full flex flex-col md:flex-row justify-between items-center md:flex-nowrap gap-4 [&_.wp-block]:w-full"
        template={[
          ["content/ctas-item", {}],
          ["content/ctas-item", {}],
          ["content/ctas-item", {}],
        ]}
      />
    </div>
  )
})
